import { hideSpinner, showSpinner } from "app/modules/cms/service/store/cms-dispatchs";
import { FMIP } from "app/shared/constants/constants";
import { geolocationApi } from "../api/geolocation";

export const checkFMIP = (imei: string, externalRef : string) => async (dispatch): Promise<FMIP> => {
    dispatch(showSpinner());
    const response = await geolocationApi.checkFMIP(imei, externalRef);

    if (response.status === 200 || response.status === 201) {
        dispatch(hideSpinner());
        return response.data;
    }
    dispatch(hideSpinner());
};


export const geoLocationPostAction = (geoLocationPostActionDTO: any) => async (dispatch): Promise<string> => {
    const response = await geolocationApi.geoLocationPostAction(geoLocationPostActionDTO);

    if (response.status === 200 || response.status === 201) {
        return response.data;
    }
};
